import { NavLink } from 'react-router-dom';
import '../css/navStyling.css'
import { useAuth } from "../utils/auth";
import { IoHomeOutline } from 'react-icons/io5';
import { GiHorseHead } from 'react-icons/gi';
import { useEffect, useState } from 'react';
import { MdOutlineAdminPanelSettings } from 'react-icons/md';
import { VscAccount } from 'react-icons/vsc';
import { AiOutlineMenuFold, AiOutlineMenuUnfold} from 'react-icons/ai';



const MainNavigation = () => {

    const auth = useAuth();

    const [foldmenu, setFoldMenu] = useState(false);

    const handleFoldClick = () => {
        setFoldMenu(prevState => !prevState);
    }

    useEffect(() => {
        const screenWidth = window.innerWidth;
        if (screenWidth < 700 || !auth.user) {
            setFoldMenu(true);
        }
    },[]);

    return (
        <>
            <div className={`navigation ${foldmenu ? "fold" : ""}`}>
                <div className='navTop'>
                    <div className='navIcon' onClick={handleFoldClick}>
                        {foldmenu ? <AiOutlineMenuUnfold /> : <AiOutlineMenuFold />}
                    </div>
                    <div className='navWebLink'>
                    {/* eslint-disable-next-line */}
                        <a href="https://www.brinkruiters.nl" target= "_blank" >RV de Brinkruiters <span>(website)</span> </a>
                    </div>

                </div>
                <nav>
                    { auth.user &&
                    <NavLink to= '/'>
                        <div className='navItem'>
                            <span className='icon'> <IoHomeOutline /></span>
                            <span className='navTitle'>Dashboard</span>
                        </div>
                    </NavLink>
                    }

                    { auth.user &&
                    <NavLink to= '/activiteiten'>
                        <div className='navItem'>
                            <span className='icon'><GiHorseHead /></span>
                            <span className='navTitle'>Activiteiten</span>

                        </div>
                    </NavLink>
                    }

                    { auth.user &&
                    <NavLink to= '/accountinstellingen'>
                        <div className='navItem'>
                            <span className='icon'><VscAccount /></span>
                            <span className='navTitle'>Account</span>

                        </div>
                    </NavLink>
                    }

                    { auth.user 
                    &&
                     (auth.c === 129763 || auth.a === 157416 || auth.s === 185391) &&
                    <NavLink to= '/admin'>
                        <div className='navItem'>
                            <span className='icon'><MdOutlineAdminPanelSettings /></span>
                            <span className='navTitle'>Admin</span>

                        </div>
                    </NavLink>
                    
                    }

                </nav>
                
            </div>
        </>
    );
}

export default MainNavigation;